import client from '@/shared/apis/client'
import {
  PharmacyComparisonResponse,
  PharmacyComparisonParams,
  // 新規追加の型
  MetricsSummaryRequest,
  MetricsSummaryResponse,
  MetricsAnalyticsRequest,
  MetricsAnalyticsResponse,
  MetricsRecordsRequest,
  MetricsRecordsResponse,
  MetricsExportRequest,
  MetricsDetail,
} from '@/features/internal/metrics/types/metrics'

// ========================================
// 新API（バックエンドリニューアル対応）
// ========================================

/**
 * 基本KPI取得（新API）
 * POST /metrics/summary/
 */
export const getMetricsSummary = async (
  params: MetricsSummaryRequest
): Promise<MetricsSummaryResponse> => {
  const response = await client.post<MetricsSummaryResponse>(
    '/api/metrics/summary/',
    params
  )
  return response.data
}

/**
 * トレンド・分布データ取得（新API）
 * POST /metrics/analytics/
 */
export const getMetricsAnalytics = async (
  params: MetricsAnalyticsRequest
): Promise<MetricsAnalyticsResponse> => {
  const response = await client.post<MetricsAnalyticsResponse>(
    '/api/metrics/analytics/',
    params
  )
  return response.data
}

/**
 * レコード一覧取得（新API）
 * POST /metrics/records/
 */
export const getMetricsRecords = async (
  params: MetricsRecordsRequest
): Promise<MetricsRecordsResponse> => {
  const response = await client.post<MetricsRecordsResponse>(
    '/api/metrics/records/',
    params
  )
  return response.data
}

/**
 * CSVエクスポート結果
 */
export interface MetricsExportResult {
  blob: Blob
  totalCount: number
  isTruncated: boolean
  exportLimit: number
}

/**
 * CSVエクスポート（新API）
 * POST /metrics/records/export/
 */
export const exportMetricsRecords = async (
  params: MetricsExportRequest
): Promise<MetricsExportResult> => {
  const response = await client.post('/api/metrics/records/export/', params, {
    responseType: 'blob',
  })
  return {
    blob: response.data,
    totalCount: parseInt(response.headers['x-total-count'] || '0', 10),
    isTruncated: response.headers['x-is-truncated'] === 'true',
    exportLimit: parseInt(response.headers['x-export-limit'] || '0', 10),
  }
}

/**
 * 詳細取得（拡張版）
 * GET /metrics/{id}/
 * 新フィールド追加: pharmacy_name, pharmacist_name, speech_rate
 */
export const getMetricsDetail = async (id: string): Promise<MetricsDetail> => {
  const response = await client.get<MetricsDetail>(`/api/metrics/${id}/`)
  return response.data
}

/**
 * 薬局別比較データを取得（恒久的に維持）
 * GET /metrics/pharmacy-comparison/
 */
export const getPharmacyComparison = async (
  params: PharmacyComparisonParams
): Promise<PharmacyComparisonResponse> => {
  const response = await client.get<PharmacyComparisonResponse>(
    '/api/metrics/pharmacy-comparison/',
    {
      params,
    }
  )
  return response.data
}
